/* eslint-disable react/prop-types */
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import PlantCheeseProduct from 'models/PlantCheeseProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import {
  packagingInitialState,
  plantCheeseAltTypeOptions,
  typeOptions,
  formOptions,
} from './constants'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import Select from 'react-select'
import { isNotAlpha } from 'context/Utilities'

const PlantCheesePackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { onChange, setSelect, asterisk } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const {
        category,
        subCategory,
        PlantCheeseAltType,
        OtherPlantCheeseAltType,
        Type,
        OtherType,
        Form,
        Size,
      } = current
      setPackaging({
        category,
        subCategory,
        PlantCheeseAltType: {
          value: PlantCheeseAltType || '',
          label:
            PlantCheeseAltType.length > 0
              ? PlantCheeseAltType
              : 'Plant-Based Cheese Alternative Type',
        },
        OtherPlantCheeseAltType,
        Type: {
          value: Type || '',
          label: Type.length > 0 ? Type : 'Cheese Type',
        },
        OtherType,
        Form: {
          value: Form || '',
          label: Form.length > 0 ? Form : 'Form',
        },
        Size,
      })
    } else if (!updating) {
      setCurrent(PlantCheeseProduct)
      setPackaging(packagingInitialState)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  useEffect(() => {
    if (updating) {
      if (current?.PlantCheeseAltType === 'Other') {
        methods.setValue(
          'OtherPlantCheeseAltType',
          current.OtherPlantCheeseAltType
        )
      }
      if (current?.Type === 'Other') {
        methods.setValue('OtherType', current.OtherType)
      }
    }
  }, [updating])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Plant-Based Cheese Alternative Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="PlantCheeseAltType"
            placeholder={'Select Plant-Based Cheese Alternative Type'}
            options={plantCheeseAltTypeOptions}
            onChange={([selected]) => {
              setSelect(selected, 'PlantCheeseAltType')
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
          />
          <p className="text-danger">
            <ErrorMessage
              errors={methods.errors}
              name="PlantCheeseAltType"
              message={'⚠ Please select a plant-based Cheese alternative type'}
              as={<Alert color="danger" className="mt-3" />}
            />
          </p>
        </FormGroup>

        {current?.PlantCheeseAltType === 'Other' && (
          <FormGroup>
            <p>
              <strong>
                Other Plant-Based Cheese Alternative Type (Please Specify){' '}
                {asterisk}
              </strong>
            </p>
            <Controller
              as={Input}
              name="OtherPlantCheeseAltType"
              placeholder={'Other Plant-Based Cheese Alternative Type'}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 15,
                  message:
                    '⚠ Other Plant-Based Cheese alternative type exceeds 15 characters.',
                },
                required: {
                  value: true,
                  message:
                    '⚠ Other plant-Based Cheese alternative type is required',
                },
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className="text-danger">
              <ErrorMessage
                errors={methods.errors}
                name="OtherPlantCheeseAltType"
                as={<Alert color="danger" className="mt-3" />}
              />
            </p>
          </FormGroup>
        )}

        <FormGroup>
          <p>
            <strong>Type {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="Type"
            placeholder={'Select Cheese Type'}
            options={typeOptions}
            onChange={([selected]) => {
              setSelect(selected, 'Type')
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
          />
          <p className="text-danger">
            <ErrorMessage
              errors={methods.errors}
              name="Type"
              message={'⚠ Please select a cheese type'}
              as={<Alert color="danger" className="mt-3" />}
            />
          </p>
        </FormGroup>

        {current?.Type === 'Other' && (
          <FormGroup>
            <p>
              <strong>Other Type (Please Specify) {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="OtherType"
              placeholder={'Other Type'}
              onKeyDown={e => {
                if (isNotAlpha(e.key) && e.key !== ' ') {
                  e.preventDefault()
                }
              }}
              control={methods.control}
              rules={{
                maxLength: {
                  value: 15,
                  message: '⚠ Other type exceeds 15 characters.',
                },
                required: { value: true, message: '⚠ Other type is required' },
              }}
              onChange={([event]) => {
                onChange(event)
                return event
              }}
            />
            <p className="text-danger">
              <ErrorMessage
                errors={methods.errors}
                name="OtherType"
                as={<Alert color="danger" className="mt-3" />}
              />
            </p>
          </FormGroup>
        )}
      </Col>

      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Form {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            name="Form"
            placeholder={'Select Form'}
            options={formOptions}
            onChange={([selected]) => {
              setSelect(selected, 'Form')
              return selected
            }}
            control={methods.control}
            rules={{ required: true }}
          />
          <p className="text-danger">
            <ErrorMessage
              errors={methods.errors}
              name="Form"
              message={'⚠ Please select a form'}
              as={<Alert color="danger" className="mt-3" />}
            />
          </p>
        </FormGroup>

        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            name="Size"
            control={methods.control}
            rules={{
              maxLength: { value: 5, message: '⚠ Size exceeds 5 characters' },
              required: { value: true, message: '⚠ Please enter product size' },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onKeyDown={e => {
              if (
                ![
                  'Backspace',
                  'Delete',
                  'Tab',
                  'ArrowLeft',
                  'ArrowRight',
                ].includes(e.key) &&
                isNaN(parseInt(e.key)) &&
                e.key !== '.'
              ) {
                e.preventDefault()
              }
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className="text-danger">
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              as={<Alert color="danger" className="mt-3" />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default PlantCheesePackage
